import { ALL_STATES } from '@/constants/location_states';

export const LANGUAGE_TO_TENANT: Record<string, string> = {
  english: 'en',
  hindi: 'hi',
  telugu: 'te',
  bengali: 'bn',
  gujarati: 'gu',
  malayalam: 'ml',
  marathi: 'mr',
  kannada: 'kn',
  odia: 'or',
  oriya: 'or',
  assamese: 'as',
  punjabi: 'pa',
  tamil: 'ta',
};

export function getTenantFromStateSlug(stateSlug: string): string {
  const state = ALL_STATES[stateSlug];
  const language = state?.language?.toLowerCase() || 'hindi';
  return LANGUAGE_TO_TENANT[language] || 'hi';
}
